export const capitalizeFirstLetter =  (string:string) => {
	return string[0].toUpperCase() + string.slice(1);
}